import { isDevMode } from '@angular/core';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import * as fromPartner from './reducers/rtmap.reducer';
import { PartnerState } from '@interfaces/state_interfaces';

export interface State {
  partner: PartnerState;
}

export const reducers: ActionReducerMap<State> = {
  partner: fromPartner.partnerReducer
};

export const metaReducers: MetaReducer<State>[] = isDevMode() ? [] : [];
